import classNames from 'classnames';
import React from 'react';

import styles from './SettingsTitle.module.scss';

export interface SettingsTitleProps {
  title: string;
  className?: string;
  titleClassName?: string;
  beforeTitle?: React.ReactNode;
  afterTitle?: React.ReactNode;
}

export function SettingsTitle(props: SettingsTitleProps) {
  const { title, beforeTitle, afterTitle, className, titleClassName } = props;

  return (
    <div className={classNames(styles.container, className)}>
      {beforeTitle}
      <div className={classNames(styles.title, titleClassName)}>{title}</div>
      {afterTitle}
    </div>
  );
}
